<template>
  <ul class="gfr-catalog">
    <GfrCatalogItem
      v-for="item in data"
      v-show="showCurrentCatalog(item)"
      :key="item.id"
      :open="item.open"
      :title="item.title"
      :active="item.url === activeUrl"
      :url="item.url ? `${prefixPath}/${item.url}/` : ''"
      :has-children="hasChildren(item)"
      @toggle-open="toggleOpen(item)"
      @open="onOpen(item)"
      @open-first-child="onOpenFirstChild(item)"
    >
      <template v-if="item.children && item.open">
        <GfrCatalog
          v-show="item.open"
          :data="item.children"
          :active-url="activeUrl"
          :prefix-path="prefixPath"
          :show-obsoleted="showObsoleted"
        />
      </template>
    </GfrCatalogItem>
  </ul>
</template>
<script lang="ts" setup>
import { CatalogsConfig } from '~/components/gfr/types/components'
import './styles/index.scss'
const router = useRouter()
const props = defineProps({
  data: {
    type: Array as PropType<CatalogsConfig[]>,
    default: () => []
  },
  activeUrl: String,
  prefixPath: String,
  showObsoleted: Boolean
})
function toggleOpen(item: CatalogsConfig) {
  item.open = !item.open
}
function onOpen(item: CatalogsConfig) {
  item.open = true
}
function onOpenFirstChild(item: CatalogsConfig) {
  const doc = findChildrenDocument(item.children || [], 'url')
  doc &&
    router.push({
      path: `${props.prefixPath}/${doc.url}/`
    })
}
const findChildrenDocument = (arr: CatalogsConfig[], key = 'url'): CatalogsConfig | undefined => {
  for (const item of arr) {
    if (item[key as keyof CatalogsConfig] && (props.showObsoleted || !item.obsoleted)) {
      return item
    } else if (item.children) {
      return findChildrenDocument(item.children, key)
    }
  }
  return undefined
}

/*
 * 如果展示废弃文章，则判断当前目录是否存在链接或有子目录
 * 如果隐藏废弃文章，则判断当前目录是否废弃，且是否有链接或者是否存在非废弃的子元素
 * 注意：数据结构重构之后，文章属于有链接的目录
 * */
const showCurrentCatalog = (item: CatalogsConfig) => {
  return props.showObsoleted
    ? item.url || item.children?.length
    : !item.obsoleted && (hasActiveChildren(item) || item.url)
}
/*
 * 递归判断是否存在非废弃的子元素,且非废弃元素有链接
 * 对于P4来说，分类没有废弃一说，但分类存在文章，为了递归结构的统一，所以目录的数据结构做了重构
 */
const hasActiveChildren = (item: CatalogsConfig): boolean => {
  if (item.children && item.children?.length > 0) {
    return item.children.some((child) => !child.obsoleted && (child.url || hasActiveChildren(child)))
  } else {
    return false
  }
}
const hasChildren = (item: CatalogsConfig) => {
  return props.showObsoleted ? item.children && item.children?.length > 0 : hasActiveChildren(item)
}
</script>
<style scoped lang="scss"></style>
